import { motion } from "framer-motion";
import { Link } from "react-router-dom";

const Hero = () => {
  return (
    <div className="relative w-full min-h-screen bg-gradient-to-br from-blue-600 via-blue-500 to-blue-400">
      <div className="absolute inset-0 bg-black/5" />

      <div className="relative container mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="desktop:max-w-3xl laptop:max-w-2xl tablet:max-w-xl mobile:max-w-full mx-auto text-center"
        >
          {/* Title */}
          <h1 className="desktop:text-6xl laptop:text-5xl tablet:text-4xl mobile:text-3xl font-bold text-white mb-6 font-sans">
            Innovative Solutions for Modern Businesses
          </h1>

          {/* Subtitle */}
          <p className="desktop:text-xl laptop:text-lg tablet:text-base mobile:text-sm text-white/90 mb-12 font-sans">
            We deliver innovative solutions that drive growth and success for
            forward-thinking companies.
          </p>

          {/* CTA Buttons */}
          <div className="flex desktop:flex-row laptop:flex-row tablet:flex-col mobile:flex-col desktop:space-x-6 laptop:space-x-6 tablet:space-y-4 mobile:space-y-4 desktop:justify-center laptop:justify-center tablet:items-stretch mobile:items-stretch">
            <Link to="/contact">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="desktop:px-8 laptop:px-8 tablet:px-6 mobile:px-6 desktop:py-4 laptop:py-4 tablet:py-3 mobile:py-3 bg-white text-blue-600 rounded-lg font-semibold shadow-lg hover:bg-blue-50 transition-colors duration-200 desktop:text-lg laptop:text-lg tablet:text-base mobile:text-base w-full"
              >
                Get Started
              </motion.button>
            </Link>

            <Link to="/learn-more">
              <motion.button
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="desktop:px-8 laptop:px-8 tablet:px-6 mobile:px-6 desktop:py-4 laptop:py-4 tablet:py-3 mobile:py-3 bg-transparent border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-colors duration-200 desktop:text-lg laptop:text-lg tablet:text-base mobile:text-base w-full"
              >
                Learn More
              </motion.button>
            </Link>
          </div>

          {/* Decorative Elements */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            transition={{ delay: 0.5, duration: 1 }}
            className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-blue-700/20 to-transparent"
          />
        </motion.div>
      </div>
    </div>
  );
};

export default Hero;
